import { render } from "./mainfw.vue?vue&type=template&id=0fcbb07c"
import script from "./mainfw.vue?vue&type=script&lang=js"
export * from "./mainfw.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__